import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Header.css";
import logo from "../../pages/assets/DreamOnF.png";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  const { t, i18n } = useTranslation();
  const isES = (i18n.language || "").startsWith("es");

  const setLang = (lng) => {
    i18n.changeLanguage(lng);
    try {
      localStorage.setItem("i18nextLng", lng);
    } catch (e) {}
  };

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 4);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [open]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  useEffect(() => {
    const onResize = () => window.innerWidth > 860 && setOpen(false);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <header
      className={`header ${scrolled ? "is-scrolled" : ""}`}
      data-open={open ? "true" : "false"}
    >
      <div className="container header__inner">
        {/* Logo */}
        <Link to="/" className="brand" aria-label="Ir al inicio">
          <img
            src={logo}
            alt="Dream On"
            className="brand__logo"
            width="140"
            height="64"
            loading="eager"
            decoding="async"
          />
        </Link>

        <button
          className="nav__toggle"
          aria-label={open ? "Cerrar menú" : "Abrir menú"}
          aria-expanded={open}
          aria-controls="primary-navigation"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        <nav
          id="primary-navigation"
          className={`nav ${open ? "is-open" : ""}`}
          role="navigation"
          aria-label="Principal"
        >
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `nav__link ${isActive ? "active" : ""}`
            }
          >
            {t("nav.home")}
          </NavLink>

          <NavLink
            to="/products"
            className={({ isActive }) =>
              `nav__link ${isActive ? "active" : ""}`
            }
          >
            {t("nav.products")}
          </NavLink>

          <NavLink
            to="/contact"
            className={({ isActive }) =>
              `nav__link ${isActive ? "active" : ""}`
            }
          >
            {t("nav.contact")}
          </NavLink>

          {/* ✅ Switch de idioma (va dentro del nav) */}
          <div className="lang" role="group" aria-label="Cambiar idioma">
            <button
              type="button"
              className={`lang__btn ${isES ? "is-active" : ""}`}
              onClick={() => setLang("es")}
              aria-pressed={isES}
            >
              ES
            </button>
            <button
              type="button"
              className={`lang__btn ${!isES ? "is-active" : ""}`}
              onClick={() => setLang("en")}
              aria-pressed={!isES}
            >
              EN
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
}
